import "./style.css"
import loader from '../../assets/lottie/loader.json'
import Lottie from 'lottie-react'

function Loader() {
    return (
        <div className="loader text-center m-4">
           <Lottie animationData={loader} style={{
                            width: '80px',
                            height: '80px',
                        }} />
        </div>
    )
}
export default Loader;